<template>
    <ob1-popin-modal-visual
        :id="modalId"
        :aria-labelledby="modalAriaLabel"
        :show-close-button="true"
        additional-classes="d-webview-none"
    >
        <template #visual>
            <div class="ob1-modal-img d-webview-none">
                <div class="image-crop">
                    <img
                        :src="visual.src"
                        :alt="visual.alt"
                    >
                </div>
            </div>
        </template>
        <template #content>
            <h4 v-html="title" />

            <template v-if="displayPromo">
                <span v-if="displayOdr" class="lead">
                    <strong v-html="modalPromoTitle" />
                </span>
                <div class="standard" v-html="modalPromoText" />
            </template>

            <template v-if="displayOdr">
                <template v-if="displayPromo">
                    <div class="py-1">
                        <hr class="separator separator--gray4">
                    </div>
                    <span class="lead">
                        <strong v-html="modalOdrTitle" />
                    </span>
                </template>
                <div class="standard" v-html="modalOdrText" />
                <ob1-liens
                    v-if="odrLink"
                    class="mb-1"
                    with-arrow
                    is-mini
                    :text="odrLinkLabel"
                    :href="odrLink"
                    target="_blank"
                />
            </template>
        </template>
    </ob1-popin-modal-visual>
</template>

<script>

export default {
    props: {
        promoAmountInCents: {
            type: Number,
            required: false,
            default: null
        },
        promoEndDate: {
            type: String,
            required: false,
            default: null
        },
        odrAmountInCents: {
            type: Number,
            required: false,
            default: null
        },
        odrStartDate: {
            type: String,
            required: false,
            default: null
        },
        odrEndDate: {
            type: String,
            required: false,
            default: null
        },
        odrLink: {
            type: String,
            required: false,
            default: null
        },
        bundlePackName: {
            type: String,
            required: false,
            default: null
        },
        deviceName: {
            type: String,
            required: false,
            default: null
        },
        devicePriceInCents: {
            type: Number,
            required: false,
            default: null
        },
        deviceDiscountedPriceInCents: {
            type: Number,
            required: false,
            default: null
        },
        promoOdrMessages: {
            type: Object,
            required: true
        },
        modalId: {
            type: String,
            required: true
        }
    },
    computed: {
        modalAriaLabel() {
            return this.modalId + "-modal"
        },
        title() {
            if (this.displayPromo && this.displayOdr) {
                return this.promoOdrMessages.modalTitle;
            } else if (this.displayPromo) {
                return this.modalPromoTitle;
            } else {
            return this.modalOdrTitle;
            }
        },
        visual() {
            return this.promoOdrMessages.visual
        },
        modalPromoTitle() {
            return this.promoOdrMessages.modalPromoTitle
        },
        modalPromoText() {
            if (this.promoEndDate) {
                if (this.bundlePackName) {
                    return this.promoOdrMessages.modalBundlePromoText
                        .replace("{0}", this.bundlePackName)
                        .replace("{1}", PriceFormatter.formatEurosWithSpace(this.deviceDiscountedPriceInCents / 100, false).toString())
                        .replace("{2}", PriceFormatter.formatEurosWithSpace(this.devicePriceInCents / 100, false).toString())
                        .replace("{3}", this.promoEndDate)
                }
                return this.promoOdrMessages.modalPromoText
                    .replaceAll("{0}", this.promoEndDate)
                    .replace("{1}", this.deviceName)
                    .replace("{2}", PriceFormatter.formatEurosWithSpace(this.deviceDiscountedPriceInCents / 100, false).toString())
                    .replace("{3}", PriceFormatter.formatEurosWithSpace(this.promoAmountInCents / 100, false).toString())
            }
            return undefined
        },
        displayPromo() {
            return !!this.modalPromoTitle && !!this.modalPromoText
        },
        modalOdrTitle() {
            return this.promoOdrMessages.modalOdrTitle
        },
        modalOdrText() {
            if (this.odrAmountInCents) {
                return this.promoOdrMessages.modalOdrText
                    .replace("{0}", PriceFormatter.formatEurosWithSpace(this.odrAmountInCents / 100, false).toString())
                    .replace("{1}", this.odrStartDate)
                    .replace("{2}", this.odrEndDate)
            }
            return undefined
        },
        displayOdr() {
            return !!this.modalOdrTitle && !!this.modalOdrText
        },
        odrLinkLabel() {
            return this.promoOdrMessages.odrLinkLabel
        }
    }
}
</script>

<style scoped lang="scss">
@media (min-width: 736px) {
    .image-crop {
        width: 405px;
        overflow: hidden;
        position: relative;
    }

    .image-crop img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
</style>
